export default __webpack_public_path__ + "static/media/proactive_logo.e0b1e57f.svg";